module.exports = __webpack_public_path__ + "static/circle-shape2-482dc50f306cf51560112b2df276a1aa.png";